import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { TestModule } from '../../models/testing/test-catalogs.model';
import { TestSubmodule, TestFunctionality } from '../../models/testing/test-location.model';

/**
 * Cascada de ubicación del issue: Módulo → Submódulo → Funcionalidad.
 */
@Injectable({ providedIn: 'root' })
export class TestLocationService {
  private api = environment.apiEndPoint;

  constructor(private http: HttpClient) {}

  getModules() {
    return this.http.get<TestModule[]>(`${this.api}/TestModule`);
  }

  getSubmodules(moduleId: number) {
    return this.http.get<TestSubmodule[]>(`${this.api}/TestSubmodule?moduleId=${moduleId}`);
  }

  getFunctionalities(submoduleId: number) {
    return this.http.get<TestFunctionality[]>(`${this.api}/TestFunctionality?submoduleId=${submoduleId}`);
  }

  // ── ABM de catálogos (usado por el mantenedor del centro de pruebas) ──
  addSubmodule(submodule: TestSubmodule) {
    return this.http.post<TestSubmodule>(`${this.api}/TestSubmodule`, submodule);
  }

  updateSubmodule(id: number, submodule: TestSubmodule) {
    return this.http.put<TestSubmodule>(`${this.api}/TestSubmodule/${id}`, submodule);
  }

  deleteSubmodule(id: number) {
    return this.http.delete(`${this.api}/TestSubmodule/${id}`);
  }

  getAllSubmodules() {
    return this.http.get<TestSubmodule[]>(`${this.api}/TestSubmodule`);
  }

  addFunctionality(functionality: TestFunctionality) {
    return this.http.post<TestFunctionality>(`${this.api}/TestFunctionality`, functionality);
  }

  updateFunctionality(id: number, functionality: TestFunctionality) {
    return this.http.put<TestFunctionality>(`${this.api}/TestFunctionality/${id}`, functionality);
  }

  deleteFunctionality(id: number) {
    return this.http.delete(`${this.api}/TestFunctionality/${id}`);
  }

  getAllFunctionalities() {
    return this.http.get<TestFunctionality[]>(`${this.api}/TestFunctionality`);
  }
}
